import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth, useToast } from '../../context/AppContext';
import api from '../../api';

export default function LoginPage() {
  const [form, setForm]       = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({});
  const { login } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/settings').then(r => setSettings(r.data.data || {})).catch(() => {});
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      addToast('Welcome back!', 'success');
      navigate('/admin/dashboard');
    } catch (err) {
      addToast(err.response?.data?.message || 'Invalid credentials', 'error');
    } finally { setLoading(false); }
  };

  const siteName = settings.site_name || 'Bacha & Son Construction';
  const [brand, accent] = siteName.includes(' ')
    ? [siteName.split(' ')[0], ' ' + siteName.split(' ').slice(1).join(' ')]
    : [siteName, ''];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(150deg, var(--c1) 0%, var(--c2-light) 50%, var(--c3-light) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', overflow: 'hidden' }}>
      {/* Decorative circles */}
      <div style={{ position: 'absolute', top: -80, right: -80, width: 400, height: 400, borderRadius: '50%', background: 'rgba(155,142,199,0.12)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -60, left: -60, width: 300, height: 300, borderRadius: '50%', background: 'rgba(180,211,217,0.18)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        <div className="text-center mb-2">
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.9rem', fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>
            {brand}<span style={{ color: 'var(--c4)' }}>{accent}</span>
          </div>
          <div style={{ fontSize: 11, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--text-muted)' }}>Admin Panel</div>
        </div>

        {/* Card */}
        <div style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(12px)', border: '1px solid rgba(155,142,199,0.2)', borderRadius: 'var(--radius-xl)', padding: 26, boxShadow: '0 16px 48px rgba(44,40,64,0.14)' }}>
          <h4 style={{ color: 'var(--text)', fontFamily: 'var(--font-display)', marginBottom: 6, fontSize: '1.25rem' }}>Sign In</h4>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: 28 }}>Enter your credentials to continue</p>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label-styled">Email Address</label>
              <input type="email" className="form-control-styled" required placeholder="admin@company.com"
                value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
            </div>
            <div className="mb-4">
              <label className="form-label-styled">Password</label>
              <input type="password" className="form-control-styled" required placeholder="••••••••"
                value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            </div>
            <button type="submit" className="btn-primary-styled w-100" disabled={loading}
              style={{ justifyContent: 'center', padding: '12px 24px', fontSize: '0.95rem', opacity: loading ? 0.75 : 1 }}>
              {loading
                ? <><div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite', display: 'inline-block', marginRight: 8 }} />Signing in...</>
                : <><i className="bi bi-box-arrow-in-right me-2" />Sign In</>
              }
            </button>
          </form>
        </div>

        <div className="text-center mt-4">
          <Link to="/" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
            <i className="bi bi-arrow-left me-1" /> Back to Website
          </Link>
        </div>
      </div>
    </div>
  );
}
